import { render, staticRenderFns } from "./ConfirmEmailButton.vue?vue&type=template&id=2308da51"
import script from "./ConfirmEmailButton.vue?vue&type=script&lang=js"
export * from "./ConfirmEmailButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports